export const GET_ADHERENTS = 'GET_ADHERENTS';
export const ADHERENTS_UPDATED = 'ADHERENTS_UPDATED';
export const MES_INVITATIONS = 'MES_INVITATIONS';
export const MES_STRUCTURES = 'MES_STRUCTURES';
